import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { PickSessionSchema } from "@redotech/redo-fulfillment-wms-common/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { UnpickedItemBinsSchema } from "./get-available-bins-for-unpicked-items";
import { ScanVerifyPopupSchema } from "./get-scan-verify-popups";
import { ScanCasePackSchema } from "./scan-case-packs";

export const getLatestOpenFulfillmentGroup = {
  name: "getLatestOpenFulfillmentGroup" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    requestSource: z.literal("scan").nullish(),
    scannedToteId: zExt.objectId().nullish(),
    knownPickSessionId: zExt.objectId().nullish(),
  }),
  output: z.object({
    fulfillmentGroup: FulfillmentGroupDataSchema,
    originalGroupWasMerged: z.boolean().nullish(),
    binsResolved: z.boolean().nullish(),
    scanVerifyPopups: z.array(ScanVerifyPopupSchema).nullish(),
    pickSession: PickSessionSchema.nullish(),
    unpickedItemBins: UnpickedItemBinsSchema.nullish(),
    casePacks: z.array(ScanCasePackSchema).nullish(),
  }),
};
